import { render, staticRenderFns } from "./AllClassify.vue?vue&type=template&id=458b523f&scoped=true"
import script from "./AllClassify.vue?vue&type=script&lang=js"
export * from "./AllClassify.vue?vue&type=script&lang=js"
import style0 from "./AllClassify.vue?vue&type=style&index=0&id=458b523f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458b523f",
  null
  
)

export default component.exports